import React from "react";
import Folder from "./Folder";
import { connect } from "react-redux";
import TargetTypeManagement from "./TargetTypeManagement";

const SEVERITY = [
    { label: 'High', id: 'High' },
    { label: 'Medium', id: 'Medium' },
    { label: 'Low', id: 'Low' }
]

function FolderNavigation({ targetTypes, targetTypesLoading }) {

    //const { locations, deviceTypes, compliance, sectors, groups, msbList } = targetTypes;

    const uniqueById = data => {
        const seen = new Set();
        return data ? data.filter(record => {
            const id = record.id || record.pk;
            if (id == null || seen.has(id)) {
                return false;
            }

            seen.add(id);
            return true;
        }) : [];
    }

    const builtinMsbs = uniqueById(targetTypes.msbList ? targetTypes.msbList.filter(msb => msb.baseMsb === true) : []);
    const customMsbs = uniqueById(targetTypes.msbList ? targetTypes.msbList.filter(msb => msb.baseMsb === false) : []);

    const {
        locations,
        deviceTypes,
        compliance,
        sectors,
        groups,
        navigationLocations,
        navigationCompliance,
        navigationSectors
    } = targetTypes;

    const mapToFolderFormat = data => data ? data.map(record => ({
        label: record.label ? record.label : record.name,
        value: record.id || record.pk
    })) : []

    return (
        <div className="oct_left-panel msb-navigation">
            {/* TargetType Action buttons (Add, Edit, Remove) */}
            <div className="mb-3">
                <TargetTypeManagement />
            </div>

            {/* Folder list styled like AddRules tabs */}
            <div className="addrules-tab-card-v2">
                <Folder data={mapToFolderFormat(groups)} filterKey={'group'} label={'Groups'} loading={targetTypesLoading} />
                <Folder data={mapToFolderFormat(navigationLocations || locations)} filterKey={'location'} label={'Locations'} loading={targetTypesLoading} />
                <Folder data={mapToFolderFormat(deviceTypes)} filterKey={'deviceType'} label={'Device Types'} loading={targetTypesLoading} />
                <Folder data={mapToFolderFormat(navigationCompliance || compliance)} filterKey={'compliance'} label={'Compliance'} loading={targetTypesLoading} />
                <Folder data={mapToFolderFormat(navigationSectors || sectors)} filterKey={'sector'} label={'Sector'} loading={targetTypesLoading} />
                <Folder data={mapToFolderFormat(SEVERITY)} filterKey={'severity'} label={'Severity'} />
                <Folder data={mapToFolderFormat(builtinMsbs)} filterKey={'msbId'} label={'Base MSB'} loading={targetTypesLoading} />
                <Folder data={mapToFolderFormat(customMsbs)} filterKey={'msbId'} label={'Custom MSB'} loading={targetTypesLoading} />
            </div>
        </div>
    )

}

function mapStateToProps(state) {
    return {
        targetTypes: state.msbPage.targetTypes || [],
        targetTypesLoading: state.msbPage.targetTypesLoading
    }
}

export default connect(mapStateToProps)(FolderNavigation);
